import NodeCache from "node-cache"

export const myCache = new NodeCache({ stdTTL: 60 * 60 * 6 }) // Cache for 6 hours